var _circle, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationRedLage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.05,
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#EE3E54"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 26,
    y: 32,
    width: 8,
    height: 8,
    fill: "#EE3E54"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 40,
    width: 8,
    height: 8,
    fill: "#EE3E54"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 26,
    y: 10,
    width: 8,
    height: 22,
    fill: "#EE3E54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationRedLage);
export default __webpack_public_path__ + "static/media/exclamation-red-lage.46c6d50cf61c23af80e7a5db2b615b4b.svg";
export { ForwardRef as ReactComponent };